
import { React } from "react";

import "./dashboard.scss";
import RecentList from "../recentlist/RecentList";
const Dashboard = () => {
  return (

    <RecentList />

  );
};

export default Dashboard;
